import { render, staticRenderFns } from "./SpenceLanding.vue?vue&type=template&id=c4ca161a&scoped=true&"
import script from "./SpenceLanding.vue?vue&type=script&lang=js&"
export * from "./SpenceLanding.vue?vue&type=script&lang=js&"
import style0 from "./SpenceLanding.vue?vue&type=style&index=0&id=c4ca161a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ca161a",
  null
  
)

export default component.exports